// Utility functions for handling image URLs

/**
 * Get the base URL for the backend server
 * @returns {string} Base URL without /api suffix
 */
export const getBackendBaseUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL || '/api';
  // Remove /api suffix to get base URL
  return apiUrl.replace('/api', '');
};

/**
 * Convert a relative image path to a full URL
 * @param {string} relativePath - Path like '/uploads/profile/image.jpg'
 * @returns {string} Full URL to the image
 */
export const getImageUrl = (relativePath) => {
  if (!relativePath) return null;
  
  // If it's already a full URL, return as is
  if (relativePath.startsWith('http://') || relativePath.startsWith('https://')) {
    return relativePath;
  }
  
  const baseUrl = getBackendBaseUrl();
  
  // Ensure path starts with /
  const path = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
  
  return `${baseUrl}${path}`;
};

/**
 * Get profile photo URL with fallback
 * @param {string} profilePhoto - Profile photo path from user data
 * @returns {string} Full URL or null
 */
export const getProfilePhotoUrl = (profilePhoto) => {
  return getImageUrl(profilePhoto);
};

/**
 * Get gallery photo URL
 * @param {string} imageUrl - Image URL from photo data
 * @returns {string} Full URL or null
 */
export const getGalleryPhotoUrl = (imageUrl) => {
  return getImageUrl(imageUrl);
};